module.exports = __webpack_public_path__ + "img/logo.b1b428f5.jpeg";